import { ArrowBack as BackIcon, Edit as EditIcon, Delete as DeleteIcon, OpenInNew} from '@mui/icons-material';
import { Button, Chip, IconButton, Stack, Typography } from '@mui/material';
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import Avatar from './Avatar';
import HotIcon from '@mui/icons-material/Whatshot';
import API from '../../../services/API';
import { useContext } from 'react';
import ToastContext from '../../../services/Context/ToastContext';

export default function Profile({person}){

    const navigate = useNavigate()

    const {setToast} = useContext(ToastContext)

    const handleDelete = () => {
        const email = window.prompt("Attention, cette action est irréversible. Entrez l'adresse email du compte pour confirmer sa suppression :");

        if(email !== person.email) return false;

        API.delete(`/crm/users/${person.id}`)
            .then(r => {
                setToast({
                    severity: 'info', 
                    message: `L'utilisateur ${person.name} a été supprimé.`, 
                    duration: 4000
                })
                return navigate('/crm/persons');
            })
            .catch(e => {
                setToast({
                    severity: 'error', 
                    message: `L'utilisateur ${person.name} n'a pas pu être supprimé.`, 
                    duration: 4000
                })
            })

        
    }

    return <Stack direction='row' justifyContent='space-between'>

        <div className="person-title">

            <IconButton sx={{mr: 1}} onClick={() => navigate(-1)}>
                <BackIcon />
            </IconButton>

            <Avatar person={person} size={50}/>

            <div className="person-name">
                <Typography variant='h5'>{person.name}</Typography>
                <small>Créé le {moment(person.createdAt).format('DD/MM/YYYY')}</small>
            </div>

            <Chip label={person.type?.title} />

            {person.hot && 
                <HotIcon color='warning' sx={{ml: 1}}/>
            }

            {person.hubspot &&
                <Button
                    href={person.hubspot.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    startIcon={<OpenInNew />}
                    sx={{m: 1}}
                >
                    Hubspot
                </Button>
            }

        </div>

        
        <Stack direction='row' spacing={1} alignItems='center'>
            <Link to={`/crm/persons/${person.id}/edit`}>
                <IconButton size='large'>
                    <EditIcon />
                </IconButton>
            </Link>

            <IconButton size='large' onClick={handleDelete}>
                <DeleteIcon />
            </IconButton>
        </Stack>

    </Stack>
}
